import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Select from 'react-select';

const SelectEditor = forwardRef((props, ref) => {
  const { value,
    onValueChange,
    stopEditing,
    values = [],
    isMulti,
    isClearable,
    isSearchable,
  } = props;

  const [options, setOptions] = useState(Array.isArray(values) ? values : []);

  const [selectedRecords, setSelectedRecords] = useState([])
  const refContainer = useRef(null);

  useEffect(() => {
    if (typeof values === 'function') {
      const options = values(props);
      setOptions(options);
    } else {
      setOptions(values);
    }
  }, [values, props]);

  useEffect(() => {
    setSelectedRecords(
      Array.isArray(value)
        ? (Array.isArray(options) ? options.filter(opt => value.includes(opt.value)) : [])
        : []
    );
  }, [options, value]);

  useEffect(() => {
    const handleFocusOut = (event) => {
      if (refContainer.current && !refContainer.current.contains(event.relatedTarget)) {
        stopEditing && stopEditing();
      }
    };

    const container = refContainer.current;
    if (container) {
      container.addEventListener('focusout', handleFocusOut);
    }
    return () => {
      if (container) {
        container.removeEventListener('focusout', handleFocusOut);
      }
    };
  }, [stopEditing]);

  useImperativeHandle(ref, () => ({
    getValue: () => selectedRecords.map(record => record.value)
  }));

  const handleChange = (newSelected) => {
    setSelectedRecords(newSelected);
    if (onValueChange) {
      onValueChange(newSelected.map(record => record.value) || [], props);
    }
  };

  return (
    <div ref={refContainer} className="agDropDown">
      <Select
        value={selectedRecords}
        onChange={handleChange}
        options={options}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        className="roleSelect"
      />
    </div>
  );
});

export default SelectEditor;